import { NewsletterSignup } from "@/components/NewsletterSignup";

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12 bg-burgundy">
      <div className="w-full max-w-4xl mx-auto text-center space-y-8">
        {/* Logo */}
        <div className="animate-fade-up">
          <img 
            src="./lovable-uploads/e65a8ebb-444f-4c66-aa22-3a4102c42946.png" 
            alt="Zevay Logo" 
            className="w-1/2 mx-auto mb-12"
          />
        </div>

        {/* Main heading */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white animate-fade-up animate-delay-100">
          Your Best Self Starts Here
        </h1>

        {/* Subheading */}
        <h2 className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto animate-fade-up animate-delay-200">
          Achieve up to 25% weight loss*
          <br />
          <span className="text-lg md:text-xl">
            Clinically proven, cost-effective, and made in the USA.
          </span>
        </h2>

        {/* Newsletter Signup */}
        <div className="mt-12 flex justify-center animate-fade-up animate-delay-300">
          <NewsletterSignup />
        </div>
      </div>
    </div>
  );
};

export default Index;